import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { CalendarIcon, UserIcon, ArrowRightIcon } from 'lucide-react';
const blogPosts = [{
  id: 1,
  title: '5 Signs You Need a New Prescription',
  excerpt: 'Are you experiencing more frequent headaches or squinting to read? It might be time to update your glasses or contact lens prescription.',
  category: 'Eye Health',
  date: 'March 15, 2026',
  author: 'Dr. Nnabue',
  image: 'https://images.unsplash.com/photo-1574482620826-40685ca5ebd2?auto=format&fit=crop&q=80&w=800',
  readTime: '4 min read'
}, {
  id: 2,
  title: 'How to Choose the Perfect Frames for Your Face Shape',
  excerpt: 'Finding the right glasses is about more than just vision. Learn how to select frames that complement your unique facial features and personal style.',
  category: 'Style & Fit',
  date: 'March 02, 2026',
  author: 'Ms. Bernice',
  image: 'https://images.unsplash.com/photo-1591076482161-42ce6da69f67?auto=format&fit=crop&q=80&w=800',
  readTime: '6 min read'
}, {
  id: 3,
  title: 'The Truth About Blue Light Glasses',
  excerpt: 'With screen time at an all-time high, blue light blocking glasses are everywhere. But do they really work? We break down the science.',
  category: 'Technology',
  date: 'February 18, 2026',
  author: 'Dr. Adaeze Nnabue',
  image: 'https://images.unsplash.com/photo-1611532736597-de2d4265fba3?auto=format&fit=crop&q=80&w=800',
  readTime: '5 min read'
}];
export function BlogExcerpts() {
  return <section className="py-20 md:py-28 bg-white" data-id="element-62">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-64">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-section-mobile md:text-section text-brand-dark mb-4 font-heading font-bold" data-id="element-65">
            From Our Blog
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-subtitle text-neutral-text/80 font-body" data-id="element-66">
            Expert tips and insights to help you take better care of your
            vision.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-67">
          {blogPosts.map((post, index) => <motion.article key={post.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-card shadow-card hover:shadow-card-hover transition-all duration-300 border border-gray-100 overflow-hidden flex flex-col h-full group cursor-pointer" data-id="element-68">
              {/* Image Container */}
              <div className="relative h-56 overflow-hidden" data-id="element-69">
                <div className="absolute inset-0 bg-brand-dark/10 group-hover:bg-transparent transition-colors duration-300 z-10" data-id="element-70" />
                <img src={post.image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" data-id="element-71" />
                <div className="absolute top-4 left-4 z-20" data-id="element-72">
                  <span className="bg-brand-gold text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-sm" data-id="element-73">
                    {post.category}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6 md:p-8 flex flex-col flex-grow" data-id="element-74">
                <div className="flex items-center gap-4 text-sm text-neutral-text/60 mb-4 font-medium" data-id="element-75">
                  <div className="flex items-center gap-1.5" data-id="element-76">
                    <CalendarIcon className="w-3.5 h-3.5 text-brand-gold" data-id="element-77" />
                    {post.date}
                  </div>
                  <div className="flex items-center gap-1.5" data-id="element-78">
                    <UserIcon className="w-3.5 h-3.5 text-brand-gold" data-id="element-79" />
                    {post.author}
                  </div>
                </div>

                <h3 className="text-xl font-heading font-bold text-brand-dark mb-3 group-hover:text-brand-gold transition-colors leading-tight" data-id="element-80">
                  <Link to={`/blog/${post.id}`} className="focus-ring rounded-sm outline-none" data-id="element-81">
                    {post.title}
                  </Link>
                </h3>

                <p className="text-neutral-text/70 mb-6 text-base leading-relaxed flex-grow" data-id="element-82">
                  {post.excerpt}
                </p>

                <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-100" data-id="element-83">
                  <span className="text-sm text-neutral-text/50 font-medium" data-id="element-84">
                    {post.readTime}
                  </span>
                  <Link to={`/blog/${post.id}`} className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-dark group-hover:text-brand-gold transition-colors focus-ring rounded-sm px-1 py-0.5" data-id="element-85">
                    Read Article
                    <ArrowRightIcon className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" data-id="element-86" />
                  </Link>
                </div>
              </div>
            </motion.article>)}
        </div>

        <div className="mt-16 text-center" data-id="element-87">
          <Link to="/blog" className="inline-flex items-center gap-2 bg-white border-2 border-brand-dark text-brand-dark px-8 py-3.5 rounded-button font-heading font-semibold hover:bg-brand-dark hover:text-white transition-colors shadow-sm focus-ring group" data-id="element-88">
            View All Articles
            <ArrowRightIcon className="w-5 h-5 transform group-hover:translate-x-1 transition-transform" data-id="element-89" />
          </Link>
        </div>
      </div>
    </section>;
}